/**
 * Optional Google Analytics 4 (gtag) when REACT_APP_GA_MEASUREMENT_ID is set.
 * Does not load any script until initOptionalGa4() runs once.
 */

declare global {
   interface Window {
      dataLayer?: unknown[];
      gtag?: (...args: unknown[]) => void;
   }
}

let ga4Initialized = false;

export function initOptionalGa4(): void {
   if (ga4Initialized || typeof window === 'undefined') return;
   const mid = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim();
   if (!mid || mid.length < 4) return;

   window.dataLayer = window.dataLayer || [];
   window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer!.push(args);
   };
   window.gtag('js', new Date());
   window.gtag('config', mid, { send_page_view: false });

   const s = document.createElement('script');
   s.async = true;
   s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(mid)}`;
   document.head.appendChild(s);

   ga4Initialized = true;
}

export function ga4PageView(pagePath: string, pageTitle?: string): void {
   const mid = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim();
   if (!mid || typeof window === 'undefined' || !window.gtag) return;
   window.gtag('config', mid, {
      page_path: pagePath,
      page_title: pageTitle,
   });
}
